import { useEffect, useState } from "react";
import emailjs from "emailjs-com";
import AOS from "aos";
import "aos/dist/aos.css";
import { FaLinkedin } from "react-icons/fa";
import AnnaImage from "../images/anna-images/Two.jpg";

export default function PartnershipComponent() {
  const [form, setForm] = useState({
    name: "",
    email: "",
    message: "",
  });

  useEffect(() => {
    AOS.init({
      duration: 1000,
      once: true,
      offset: 120,
      easing: "ease-out-cubic",
    });
  }, []);

  const sendEmail = (e) => {
    e.preventDefault();

    emailjs
      .send(
        "service_j59psjt",
        "template_64iqwnm",
        {
          from_name: form.name,
          from_email: form.email,
          message: form.message,
        },
        "eqTHHilKAHMojJBHt"
      )
      .then(() => {
        alert("Message sent successfully!");
        setForm({ name: "", email: "", message: "" });
      })
      .catch((error) => {
        console.error("EmailJS Error:", error);
        alert("Failed to send message.");
      });
  };

  return (
    <section className="bg-[#0F172A] text-white py-14 lg:py-24 px-6 md:px-16 lg:px-24">

      <div className="max-w-7xl mx-auto">

        {/* ================= TOP INTRO ================= */}
        <div data-aos="fade-up" className="mb-10 max-w-3xl">

          <p className="tracking-[0.3em] text-xs text-gray-400 mb-6">
            ANNA OKWARA FOUNDATION
          </p>

          <h2
            data-aos="fade-up"
            data-aos-delay="100"
            className="text-3xl md:text-6xl font-semibold leading-tight"
          >
            Partnerships Built on Execution,
            <span className="block text-green-400">
              Not Just Ideas
            </span>
          </h2>

          <p
            data-aos="fade-up"
            data-aos-delay="200"
            className="mt-6 text-gray-400 leading-relaxed"
          >
           Together, we can transform bold ideas into scalable programs that deliver lasting environmental, social, and economic impact
          </p>

        </div>

        {/* ================= FOUNDER FEATURE ================= */}
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-20 items-center mb-16 lg:mb-32">

          {/* IMAGE */}
          <div
            data-aos="fade-right"
            className="relative overflow-hidden rounded-[28px] group"
          >
            <img
              src="https://media.istockphoto.com/id/1659129669/photo/welcome-handshake-and-people-with-b2b-farm-deal-for-agriculture-partnership-or-small-business.jpg?s=612x612&w=0&k=20&c=_774YlIJmeNVEZj0wOgWv9BIbtdJmKd4O0-VSElkcVA="
              alt="African women working in sustainable agriculture"
              className="w-full h-[520px] object-cover rounded-[28px] group-hover:scale-105 transition-all duration-700"
            />
          </div>

          {/* TEXT */}
          <div className="space-y-6" data-aos="fade-left">

            <h2 className="text-2xl md:text-4xl font-semibold">
              A Different Approach to Climate Work
            </h2>

            <p className="text-gray-400 leading-relaxed">

              ANNA OKWARA Foundation is focused on building systems that move
              beyond reports and planning frameworks into practical, working
              solutions within communities that strengthen long-term resilience.
              We welcome partnerships with individuals and organizations
              committed to turning climate ideas into lasting impact.

            </p>

            <div className="flex gap-4 pt-4">

              <a
                href="https://www.linkedin.com/company/anna-foundations/"
                rel="noreferrer"
                target="_blank"
                className="flex items-center gap-2 px-6 py-3 border border-green-400 rounded-full hover:bg-green-400 hover:text-[#0F172A] transition"
              >
                <FaLinkedin />
                ANNA OKWARA Foundation
              </a>

            </div>

          </div>

        </div>

        {/* ================= PARTNERSHIP STRIP ================= */}
        <div className="mb-20 lg:mb-32">

          <div
            data-aos="fade-up"
            className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-8"
          >

            <div className="max-w-3xl">

              <p className="tracking-[0.3em] text-sm text-gray-400 mb-4">
                Partner With Us for Scalable Impact
              </p>

              <p className=" md:text-lg text-gray-300 leading-relaxed">
           Together, we can transform bold ideas into scalable programs that deliver lasting environmental, social, and economic impact.
              </p>

            </div>

            <a
              href="https://www.linkedin.com/company/anna-foundations/"
              target="_blank"
              rel="noopener noreferrer"
              className="border border-green-400 text-white hover:bg-green-400 hover:text-[#0F172A] px-8 py-4 rounded-full transition-all duration-300 whitespace-nowrap"
            >
              Explore Partnership Opportunities
            </a>

          </div>

        </div>

        {/* ================= CONTACT ================= */}
        <div className="grid lg:grid-cols-2 gap-10 lg:gap-20 items-start">

          {/* LEFT */}
          <div data-aos="fade-right">

            <h2 className="text-2xl md:text-4xl font-semibold mb-6">
              Start a Conversation
            </h2>

            <p className="text-gray-400 max-w-md">
              If you are looking to build, fund, or collaborate —
              reach out directly. We keep things simple and focused.
            </p>

            {/* Desktop ONLY */}
            <div className="hidden lg:block text-sm mt-10">

              <p className="mb-2 text-lg">
                Prefer email?
              </p>

              <a
                href="mailto:kanna@annafndtn.org"
                className="text-green-400 hover:text-white transition text-lg"
              >
                kanna@annafndtn.org
              </a>

            </div>

          </div>

          {/* FORM */}
          <div>

            <form
              onSubmit={sendEmail}
              data-aos="fade-left"
              className="space-y-6"
            >

              <input
                type="text"
                placeholder="Your Name"
                value={form.name}
                onChange={(e) =>
                  setForm({ ...form, name: e.target.value })
                }
                className="w-full bg-transparent border-b border-white/30 py-3 placeholder-gray-500 focus:outline-none focus:border-green-400"
              />

              <input
                placeholder="Your Email"
                type="email"
                value={form.email}
                onChange={(e) =>
                  setForm({ ...form, email: e.target.value })
                }
                className="w-full bg-transparent border-b border-white/30 py-3 placeholder-gray-500 focus:outline-none focus:border-green-400"
              />

              <textarea
                rows="4"
                placeholder="What are you looking to build?"
                value={form.message}
                onChange={(e) =>
                  setForm({ ...form, message: e.target.value })
                }
                className="w-full bg-transparent border-b border-white/30 py-3 placeholder-gray-500 focus:outline-none focus:border-green-400"
              />

              <button
                type="submit"
                className="mt-4 px-8 py-3 bg-green-400 rounded-full text-[#0F172A] hover:bg-white transition"
              >
                Send Message
              </button>

            </form>

            {/* Mobile ONLY */}
            <div className="lg:hidden text-sm mt-10">

              <p className="mb-2 text-lg">
                Prefer email?
              </p>

              <a
                href="mailto:kanna@annafndtn.org"
                className="text-green-400 hover:text-white transition text-lg"
              >
                kanna@annafndtn.org
              </a>

            </div>

          </div>

        </div>

      </div>
    </section>
  );
}